module.exports = __webpack_public_path__ + "static/media/grid2.0b793043.jpg";